import {useTranslation} from "react-i18next";
import ShowItem from "../ShowItem";
import {COLORS} from '../theme';
import ColorPicker from "../forms/inputs/ColorPicker";
import {Button} from "react-bootstrap";
import Icon from "../Icon";
import React from "react";

export default function ColorShowItem({name, onChange, value, placeholder, editable = false, labelStyle}) {
  const { t } = useTranslation();

  const wideLabels = {
    sm: 6,
    md: 6,
    lg: 6,
    xl: 6
  }

  const clear = () => onChange(null)

  return <ShowItem
    {...wideLabels}
    label={t("cmp.popup." + name)}
    lastChildBorder={true}
    labelStyle={labelStyle}
    valueStyle={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
    <div style={{display: 'inline-block', backgroundColor: `${placeholder || 'white'}`, width: "15px", height: "20px", float: 'right', border: `1px solid ${COLORS.lightGrey}`, borderTopLeftRadius: '3px', borderBottomLeftRadius: '3px' }} />
    <ColorPicker value={value} onChange={onChange} disabled={!editable}/>
    {editable && <Button onClick={clear} variant={"light"} style={{marginLeft: '5px'}}>
      <Icon icon={"trash"} style={{marginRight: 'initial'}}/>
    </Button>}
  </ShowItem>
}

